import React from 'react';
import { Link } from 'wouter';
import { ArrowRight, Calendar } from 'lucide-react';

const blogPosts = [
  {
    id: 1,
    title: 'The Hidden Health Benefits of Pure Turmeric (Curcumin)',
    excerpt: 'Discover why turmeric has been the golden child of Ayurveda for centuries and how high curcumin content impacts your health.',
    image: 'https://images.unsplash.com/photo-1615485925600-97237c4fc1ec?auto=format&fit=crop&q=80&w=800',
    date: 'Oct 12, 2023',
    category: 'Health & Wellness'
  },
  {
    id: 2,
    title: 'How to Identify Pure vs. Adulterated Chilli Powder',
    excerpt: 'Is your chilli powder mixed with artificial colors or sawdust? Here are 3 simple water tests you can do at home to check purity.',
    image: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=800',
    date: 'Sep 28, 2023',
    category: 'Quality Tips'
  },
  {
    id: 3,
    title: 'The Secret to a Perfect Restaurant-Style Gravy: Garam Masala',
    excerpt: 'Ever wondered why restaurant curries taste so different? It all comes down to when and how you add your Garam Masala.',
    image: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&q=80&w=800', // Reusing image for prototype
    date: 'Sep 15, 2023',
    category: 'Cooking Guides'
  }
];

export default function Blog() {
  return (
    <div className="min-h-screen bg-spice-light py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="h-[1px] w-8 bg-spice-red"></span>
            <span className="text-spice-red font-bold text-xs uppercase tracking-[0.2em]">Journal</span>
            <span className="h-[1px] w-8 bg-spice-red"></span>
          </div>
          <h1 className="text-3xl md:text-5xl font-serif font-bold text-spice-dark mb-4">Spice & Wellness</h1>
          <p className="text-base md:text-lg text-spice-muted max-w-2xl mx-auto">
            Tips, recipes, and insights directly from the experts of the Indian spice industry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {blogPosts.map(post => (
            <article key={post.id} className="bg-white rounded-none border border-spice-border flex flex-col group cursor-pointer hover:shadow-xl transition-all duration-300">
              <div className="h-64 overflow-hidden relative">
                <img src={post.image} alt={post.title} referrerPolicy="no-referrer" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute top-4 left-4 bg-spice-dark text-white px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest">
                  {post.category}
                </div>
              </div>
              <div className="p-8 flex-1 flex flex-col">
                <div className="flex items-center text-[10px] uppercase tracking-widest text-spice-muted mb-4 font-bold">
                  {post.date}
                </div>
                <h2 className="text-xl md:text-2xl font-serif font-bold text-spice-dark mb-4 leading-snug">{post.title}</h2>
                <p className="text-spice-muted text-sm mb-6 leading-relaxed flex-1">{post.excerpt}</p>
                
                <button className="text-spice-red font-bold text-xs uppercase tracking-[0.2em] inline-flex items-center hover:text-spice-dark transition-colors mt-auto w-fit">
                  Read Article <span className="ml-2 font-serif text-lg leading-none">→</span>
                </button>
              </div>
            </article>
          ))}
        </div>

      </div>
    </div>
  );
}
